import { PlayForWorkRounded } from '@material-ui/icons';
import {APIBASE, CURRENTDAYKEY, CURRENTLESSONATTEMPTKEY, CURRENTLESSONKEY, CURRENTUSERID, CURRENTUSERNAME, LOCALSTORENAME, LOGINSTORENAME, MEDIABASE, PROFILEKEY, SUBSCRIPTIONKEY, TOKENKEY, CURRENTDESIGNATION, PL_APIBASE, CURRENTUSEREMAIL, CURRENTUSERCODE} from './constants';

import { STRIPE_KEY } from './env';


export function saveItem(key, val) {
  if (typeof val === 'string') {
    sessionStorage[key] = val
  }
  else{
    sessionStorage[key] = JSON.stringify(val)
  }
}

function clearItems() {
  sessionStorage.clear();
}

function getItem(key) {
  const existing = sessionStorage.getItem(key) || '{}'
  try {
    const value = JSON.parse(existing);
    return value;
  } catch (e) {
    // // outdisp('err data:' + e);
    return existing;
  }

}

export function getStripeKey() {
  return STRIPE_KEY;
}

export function isUserLoggedIn() {
  return Object.keys(getItem(PROFILEKEY)).length > 0;
}

export function isFirstLogIn() {
    // return getItem(PROFILEKEY).Profiledata.school === 'DEFAULT';
    return false;
}

export function isBasicPreassessmentDone() {
    return getItem(PROFILEKEY).PreAssesmentDone;
}

export function userFirstName() {
  if(currentDesignation() ==="admins"){
    return "Admin";
  }
  return getItem(PROFILEKEY).Profiledata.first_name.length > 0 ? getItem(PROFILEKEY).Profiledata.first_name : getItem(PROFILEKEY).Profiledata.username;
}

/*export function isUpgradePreassessmentDone() {

    return getItem(PROFILEKEY).UpgradedPreAssesmentDone;
}*/
export function isLessonsEnabled() {
  // returns whether lessons should be available or not in the current subscribed package
  if(getItem(PROFILEKEY).Profiledata.package_info === null){
    return false;
  }
  return getItem(PROFILEKEY).Profiledata.package_info.PackageFeatures.lessons;
}

export function currentTargetGroup() {
  // returns whether lessons should be available or not in the current subscribed package
  return getItem(PROFILEKEY).Profiledata.package_info.TargetGroup;
}

export function isUserUpgraded() {
  return getItem(SUBSCRIPTIONKEY).SubscriptionLevel;
}

export function hasActiveSubscription() {
  return getItem(SUBSCRIPTIONKEY).SubscriptionStatus !== -1;
}

export function currentUser() {
  return getItem(CURRENTUSERNAME);
}

export function currentProfile() {
  return getItem(PROFILEKEY);
}

export function isHomeScreenDisabled () {
  const prof = getItem(PROFILEKEY) as any;
  return prof.Profiledata.HomescreenDisabled;
}

export function currentUserAge() {
  const prof = getItem(PROFILEKEY) as any;
  const dob = new Date(prof.Profiledata.dob)
  const today = new Date();
  const diff = (today.getFullYear() - dob.getFullYear())

  return Math.round(diff);
}

export function getUserAge(dobstr) {
  const dob = new Date(dobstr);
  const today = new Date();
  const diff = (today.getFullYear() - dob.getFullYear())
  return Math.round(diff);
}

export function isSubscriptionOwner() {
  const prof = getItem(PROFILEKEY) as any;
  return prof.IsSubScriptionOwner;
}

export function plLevel() {
  const prof = getItem(PROFILEKEY) as any;
  if(typeof prof.Profiledata.PlexLevel === 'undefined') {return 0;}
  return prof.Profiledata.PlexLevel;
}

export function zeroPaddedStr(num) {
  if(num < 10) {
    return '0' + Math.abs(num)
  }
  else {
    return '' + num
  }
}

export function determineFill(alertLevel) {
  if(alertLevel === 1) {
      return "#18ee97";
  }
  else if(alertLevel ===  2) {
      return "#feb743";
  }
  else if(alertLevel === 3){
      return "#f56f3f";
  }
  else if(alertLevel === 4){
    return "#8e0666";
  }
  else if(alertLevel === 5){
      return "#e7233d";
  }
  else {
      return "#000";
  }
}

export function calcColor(level) {
    if (level > 0 && level <= 20) {
        return "#e7233d";
    }
    else if (level > 20 && level <= 40) {
        return "#8e0666";
    }
    else if (level > 40 && level <= 60) {
        return "#f56f3f";
    }
    else if (level > 60 && level <= 80) {
        return "#feb743";
    }
    else if (level > 80 && level <= 100) {
        return "#18ee97";
    }
    else {
        return "#00000000";
    }
};

export function courseScoreColor(level) {
   if (level <= 5) {
        return "#e7233d";
    }
    else if (level > 5 && level <= 25) {
        // return "#8e0666";
        return "#d20c97";
    }
    else if (level > 25 && level <= 50) {
        return "#f56f3f";
    }
    else if (level > 50 && level <= 75) {
        return "#feb743";
    }
    else if (level > 76 && level <= 100) {
        return "#18ee97";
    }
    else {
        return "#fff";
    }
}

export function courseScoreText(level) {
   if (level <= 5) {
        return "Needs a major boost";
    }
    else if (level > 5 && level <= 25) {
        return "Good start, long way to go";
    }
    else if (level > 25 && level <= 50) {
        return "Good effor, room to improve";
    }
    else if (level > 50 && level <= 75) {
        return "Good work, keep up the momentum";
    }
    else if (level > 76 && level <= 100) {
        return "Outstanding performance, keep it up";
    }
    else {
        return `${level}%`;
    }
}
export function scoreRangeKeys(level) {
   if (level <= 5) {
        return "range_1";
    }
    else if (level > 5 && level <= 25) {
        return "range_2";
    }
    else if (level > 25 && level <= 50) {
        return "range_3";
    }
    else if (level > 50 && level <= 75) {
        return "range_4";
    }
    else if (level > 76 && level <= 100) {
        return "range_5";
    }
    else {
        return `range_5`;
    }
}


export function alertLevelColor(alertLevel) {
  if(alertLevel.toLowerCase().includes('severe') || alertLevel.toLowerCase().includes('extremely')) {
         return "#e7233d";
      }
      else if(alertLevel.toLowerCase().includes('high')) {
          return "#8e0666";
      }
      else if(alertLevel.toLowerCase().includes('moderate')){
          return "#f56f3f";
      }
      else if(alertLevel.toLowerCase().includes('low')){
        return "#feb743";
      }
      else if(alertLevel.toLowerCase().includes('no')){
          return "#18ee97";
      } 
      else {
          return "#000";
      }
}
export function determineAlertLevel(value) {
  if (value >= 0 && value <= 20) {
    return "Extremely High Alert";
  }
  else if (value > 20 && value <= 40) {
    return "High Alert";
  }
  else if (value > 40 && value <= 60) {
    return "Moderate Alert";
  }
  else if (value > 60 && value <= 80) {
    return "Low Alert";
  }
  else if (value > 80 && value <= 100) {
    return "No Alert";
  }
  else {
    return "#000";
  }
}
export function currentUserDob() {
  const prof = getItem(PROFILEKEY) as any;
  // const dob = new Date(prof.Profiledata.dob)
  return prof.Profiledata.dob;
}

export function currentUserSchool() {
  const prof = getItem(PROFILEKEY) as any;

  return prof.Profiledata.school
}

export function currentUserId() {
    return getItem(CURRENTUSERID);
}

// determines the base url eg. admins, students
export function currentBaseUrl() {

  if(getItem(CURRENTDESIGNATION)) {
    return '/' + getItem(CURRENTDESIGNATION).name + '/';
  }

  return '/';

}

export function currentDesignation() {

  if(getItem(CURRENTDESIGNATION)) {
    return getItem(CURRENTDESIGNATION).name;
  }

  return '';

}

export function currentSubscriptionLevel() {
  if(getItem(SUBSCRIPTIONKEY)) {
    return getItem(SUBSCRIPTIONKEY).SubscriptionLevel;
  }
  return 0;
}


export function currentAvatar() {
  if (getItem(PROFILEKEY).Profiledata) {
    return getItem(PROFILEKEY).Profiledata.avatar;
  }
  else{
    return '';
  }
}



export function iconUrl(filename) {

    return MEDIABASE + 'icons/' + filename;
}

export function currentToken() {
  return getItem(TOKENKEY);
}

export function currentLesson() {

  return getItem(CURRENTLESSONKEY); 

}

export function currentLessonAttempt() {
  return getItem(CURRENTLESSONATTEMPTKEY); 
}

export function currentUserEmail() {
  return getItem(CURRENTUSEREMAIL);
}

export function currentUserCode() {
  return getItem(CURRENTUSERCODE);
}

export function selectedCalendarDay() {

  try{
    const is = new Date(getItem(CURRENTDAYKEY).val);
    // outdisp(is + ':' + CURRENTDAYKEY);
    return is;
  }
  catch(e){
    return new Date();
  }
}

export function setSelectedCalendarDay(newday) {

  const item = {
    'val': newday
  }
  saveItem(CURRENTDAYKEY, item);
}

export function setCurrentLesson(newlesson) {
  saveItem(CURRENTLESSONKEY, newlesson);
}

export function setCurrentLessonAttempt(attempt) {
  saveItem(CURRENTLESSONATTEMPTKEY, attempt);
}

export function setProfileData(newprofiledata) {
  const currentProf = getItem(PROFILEKEY);
  currentProf.Profiledata = {...currentProf.Profiledata, ...newprofiledata};

  saveItem(PROFILEKEY, currentProf);
}

export function setSubscriptionData(newsubdata) {
  const currentSub = getItem(SUBSCRIPTIONKEY);
  const newSubscript = { ...currentSub, ...newsubdata };
  saveItem(SUBSCRIPTIONKEY, newSubscript);
}

export function setPreAssessmentComplete() {
  const prof = getItem(PROFILEKEY);
  prof.PreAssesmentDone = true;
  saveItem(PROFILEKEY, prof);
}

export function setUpgradedAssessmentComplete() {
  const prof = getItem(PROFILEKEY);
  prof.UpgradedPreAssesmentDone = true;
  saveItem(PROFILEKEY, prof);
}

export function clearSessionData() {
  clearItems();
}

export function getTeacherLinkedSchool() {
    const prof = getItem(PROFILEKEY);
    return prof.Profiledata.school;
}

export function requiredPloa() {
  const prof = getItem(PROFILEKEY);
  return prof.Profiledata.required_ploa;
}

export const uploadItem = (endpoint, formdata, progresscallback, callback) => {

        const xhr = new XMLHttpRequest();
        // Upload progress
        xhr.upload.addEventListener("progress", (evt) =>{
          if (evt.lengthComputable) {
            const percentComplete = evt.loaded / evt.total;
            // Do something with upload progress
            // outdisp(percentComplete);
            const pc = percentComplete * 100;
            const fixed = pc.toFixed(1);
            progresscallback(parseFloat(fixed));
          }
        }, false);

        xhr.onreadystatechange = (evt) => {
          if (xhr.readyState === 4 && xhr.status === 201) {
              callback({'response': xhr.responseText, 'code': 200});
          }
          if (xhr.readyState === 4 && xhr.status >= 300) {
            callback({'response': xhr.responseText, 'code': 404});
          }
        };

        xhr.open("POST", APIBASE + endpoint);
        xhr.setRequestHeader('Authorization', 'Bearer ' + currentToken());
        // xhr.setRequestHeader('Accept', 'application/json');
        xhr.send(formdata);
  };

  export const signup = (userinfo, callback) => {
    const Params = Object.keys(userinfo).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(userinfo[key]);
    }).join('&');
    fetch(APIBASE + `admin/users/register/`, {
      body: Params,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
    })
    .then(checkStatus)
    .then(res => res.json())
    .then(res => {
      // outdisp(res);
      callback({'response': res.data, 'code': 200});
    })
    .catch(res => {
      // outdisp(res);
      callback({'response': {}, 'code': 404});
    })
};

export const login = (userinfo, callback) => {
      fetch(PL_APIBASE + `users/token-auth/`, {
        body: JSON.stringify({
          password: userinfo.password,
          username: userinfo.username,
        }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
      })
      .then(checkStatus)
      .then(res => res.json())
      .then(res => {
        // outdisp(res);
        // if (res.subscription.SubscriptionStatus === -1) {
        //   callback({'response': {}, 'code': 404});
        //   return;
        // }
        saveItem(PROFILEKEY, res.profile);
        saveItem(SUBSCRIPTIONKEY, res.subscription);
        saveItem(TOKENKEY, res.token);
        saveItem(CURRENTDESIGNATION, res.designation);
        saveItem(PROFILEKEY, res.profile);
        saveItem(CURRENTUSERNAME, res.userinfo.username);
        saveItem(CURRENTUSERID, res.userinfo.id);
        saveItem(CURRENTUSEREMAIL, res.userinfo.email);
        saveItem(CURRENTUSERCODE, res.profile.ParentStudentCode);

        callback({'response': res, 'code': 200});
      })
      .catch(res => {
        // outdisp(res);
        callback({'response': {}, 'code': 404});
      })
  };


  export const ssoRedirect = (callback) => {

    fetch(PL_APIBASE + `users/ms-login`, { method: 'GET', redirect: "error" })
    .then(handleRedirect)
    .then(response => {
      window.location.href = response.url;
    })
  }

  export const ssoRedirectGoogle = (callback) => {

    fetch(PL_APIBASE + `users/google-login`, { method: 'GET', redirect: "error" })
    .then(handleRedirect)
    .then(response => {
      window.location.href = response.url;
    })
  }

  export const ssoLogin = (userinfo, callback) => {
    fetch(PL_APIBASE + `users/token-auth-verify/`, {
      body: JSON.stringify({
        token: userinfo.token
      }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    })
    .then(checkStatus)
    .then(res => res.json())
    .then(res => {
      // outdisp(res);
      // if (res.subscription.SubscriptionStatus === -1) {
      //   callback({'response': {}, 'code': 404});
      //   return;
      // }
      saveItem(PROFILEKEY, res.profile);
      saveItem(SUBSCRIPTIONKEY, res.subscription);
      saveItem(TOKENKEY, res.token);
      saveItem(CURRENTDESIGNATION, res.designation);
      saveItem(PROFILEKEY, res.profile);
      saveItem(CURRENTUSERNAME, res.userinfo.username);
      saveItem(CURRENTUSERID, res.userinfo.id);
      saveItem(CURRENTUSEREMAIL, res.userinfo.email);
      saveItem(CURRENTUSERCODE, res.profile.ParentStudentCode);

      callback({'response': res, 'code': 200});
    })
    .catch(res => {
      // outdisp(res);
      callback({'response': {}, 'code': 404});
    })
};


export const createItemGen = (mgrendpoint, iteminfo, callback) => {
  const Params = Object.keys(iteminfo).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(iteminfo[key]);
  }).join('&');

  fetch(APIBASE + mgrendpoint, {
    body: Params,
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + currentToken() ,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'POST',
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(res => {
    // outdisp(res);
    callback({'response': res, 'code': 200});
  })
  .catch(res => {
    // outdisp(res);
    if(String(res.statustext) ==='Unauthorized'){
      // outdisp('token expired');
      clearSessionData();
      callback({'response': {}, 'code': 401});
    }
    else{
      callback({'response': {}, 'code': 404});
    }
  })
};

export const createItemJson = (mgrendpoint, iteminfo, callback) => {
  fetch(APIBASE + mgrendpoint, {
    body: JSON.stringify(iteminfo),
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + currentToken() ,
      'Content-Type': 'application/json'
    },
    method: 'POST',
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(res => {
    // outdisp(res);
    callback({'response': res, 'code': 200});
  })
  .catch(res => {
    // outdisp(res);
    if(String(res.statustext) ==='Unauthorized'){
      // outdisp('token expired');
      clearSessionData();
      callback({'response': {}, 'code': 401});
    }
    else{
      callback({'response': {}, 'code': 404});
    }
  })
};

export const createItemJsonPLApi = (mgrendpoint, iteminfo, callback) => {
  fetch(PL_APIBASE + mgrendpoint, {
    body: JSON.stringify(iteminfo),
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + currentToken() ,
      'Content-Type': 'application/json'
    },
    method: 'POST',
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(res => {
    // outdisp(res);
    callback({'response': res, 'code': 200});
  })
  .catch(res => {
    // outdisp(res);
    if(String(res.statustext) ==='Unauthorized'){
      // outdisp('token expired');
      clearSessionData();
      callback({'response': {}, 'code': 401});
    }
    else{
      callback({'response': {}, 'code': 404});
    }
  })
};

export const signupJson = (mgrendpoint, iteminfo, callback) => {
  fetch(APIBASE + mgrendpoint, {
    body: JSON.stringify(iteminfo),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(res => {
    // outdisp(res);
    callback({'response': res, 'code': 200});
  })
  .catch(res => {
    // outdisp(res);
    if(String(res.statustext) ==='Unauthorized'){
      // outdisp('token expired');
      clearSessionData();
      callback({'response': {}, 'code': 401});
    }
    else{
      callback({'response': {}, 'code': 404});
    }
  })
};

export const updateItemGen = (mgrendpoint, iteminfo, callback) => {
  const Params = Object.keys(iteminfo).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(iteminfo[key]);
  }).join('&');

  fetch(APIBASE + mgrendpoint, {
    body: Params,
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + currentToken() ,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'PUT',
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(res => {
    // outdisp(res);
    callback({'response': res.data, 'code': 200});
  })
  .catch(res => {
    // outdisp(res);
    if(String(res.statustext) ==='Unauthorized'){
      // outdisp('token expired');
      clearSessionData();
      callback({'response': {}, 'code': 401});
    }
    else{
      callback({'response': {}, 'code': 404});
    }
  })
};

export const deleteItemGen = (mgrendpoint, callback) => {

  fetch(APIBASE + mgrendpoint, {
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + currentToken() ,
    },
    method: 'DELETE',
  })
  .then(checkStatus)
  .then(res => {
    // outdisp(res);
    callback({'response': 'ok', 'code': 200});
  })
  .catch(res => {
    // // outdisp(res);
    if(String(res.statustext) ==='Unauthorized'){
      // outdisp('token expired');
      clearSessionData();
      callback({'response': {}, 'code': 401});
    }
    else{
      callback({'response': {}, 'code': 404});
    }
  })
};

export const getGenOverview = (endpoint, callback) => {
  // outdisp("tokenx:" + currentToken());

  fetch(APIBASE + endpoint, {
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + currentToken() ,
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(res => {
    // // outdisp(res);
    callback({'response': res, 'code': 200});
  })
  .catch(res => {
    // // outdisp(res);
    if(String(res.statustext) ==='Unauthorized'){
        // outdisp('token expired');
        clearSessionData();
        callback({'response': {}, 'code': 401});
    }
    else{
        callback({'response': {}, 'code': 404});
    }
  })
};

export const getGeneralSmartTableData = (apipath, callback) => {
  // // outdisp("tokenx:" + currentToken());
  // smart table data is paginated on the component side, for use with low to moderate data

  fetch(APIBASE + apipath + ``, {
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + currentToken() ,
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(res => {
    // // outdisp(res);
    callback({'response': res, 'code': 200});
  })
  .catch(res => {
    // // outdisp(res);
    if(String(res.statustext) ==='Unauthorized'){
        // outdisp('token expired');
        clearSessionData();
        callback({'response': {}, 'code': 401});
    }
    else{
        callback({'response': {}, 'code': 404});
    }
  })
}; 

export const getGeneralSmartTableDataPLApi = (apipath, callback) => {
  // // outdisp("tokenx:" + currentToken());
  // smart table data is paginated on the component side, for use with low to moderate data

  fetch(PL_APIBASE + apipath + ``, {
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + currentToken() ,
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(res => {
    // // outdisp(res);
    callback({'response': res, 'code': 200});
  })
  .catch(res => {
    // // outdisp(res);
    if(String(res.statustext) ==='Unauthorized'){
        // outdisp('token expired');
        clearSessionData();
        callback({'response': {}, 'code': 401});
    }
    else{
        callback({'response': {}, 'code': 404});
    }
  })
};

export const getGeneralSmartTableDataNoAuth = (apipath, callback) => {
  // // outdisp("tokenx:" + currentToken());
  // smart table data is paginated on the component side, for use with low to moderate data

  fetch(APIBASE + apipath + ``, {
    headers: {
      'Accept': 'application/json'
    },
    method: 'GET',
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(res => {
    // // outdisp(res);
    callback({'response': res, 'code': 200});
  })
  .catch(res => {
    // // outdisp(res);
    if(String(res.statustext) ==='Unauthorized'){
        // outdisp('token expired');
        clearSessionData();
        callback({'response': {}, 'code': 401});
    }
    else{
        callback({'response': {}, 'code': 404});
    }
  })
};

export const getGeneralDirect = (apipath, callback) => {
  // // outdisp("tokenx:" + currentToken());
  // smart table data is paginated on the component side, for use with low to moderate data

  fetch(apipath + ``, {
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + currentToken() ,
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(res => {
    // // outdisp(res);
    callback({'response': res, 'code': 200});
  })
  .catch(res => {
    // // outdisp(res);
    if(String(res.statustext) ==='Unauthorized'){
        // outdisp('token expired');
        clearSessionData();
        callback({'response': {}, 'code': 401});
    }
    else{
        callback({'response': {}, 'code': 404});
    }
  })
};


function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response
    } else {
      const error = new Error(response.statusText)
      const key = 'response';
      const key2 = 'statustext';
      error[key] = response
      error[key2] = response.statusText
      throw error
    }
  }


  function handleRedirect(response) {
    if (response.status >= 200 && response.status < 300) {
      return response.json()
    } else {
      const error = new Error(response.statusText)
      const key = 'response';
      const key2 = 'statustext';
      error[key] = response
      error[key2] = response.statusText
      throw error
    }
  }



// WEBPACK FOOTER //
// ./src/common/services.ts